import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from "remark-gfm";
import remarkHeadingId from "remark-heading-id";
import { Heading } from '../components/heading';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { useSearchParams } from 'react-router-dom';

const DocPreview = () => {
  const [docMarkdown, setDocMarkdown] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [searchParams] = useSearchParams();
  const documentId = searchParams.get('docId');

  useEffect(() => {
    const loadDocument = async () => {
      if (!documentId) {
        setDocMarkdown('No document ID provided');
        return;
      }

      try {
        const functions = getFunctions();
        const getDocumentMarkdown = httpsCallable(functions, 'getDocumentMarkdown');
        const result = await getDocumentMarkdown({ documentId });
        setDocMarkdown(result.data.markdown);
      } catch (error) {
        console.error('Error loading document:', error);
        setDocMarkdown('Error loading document content');
      }
    };

    loadDocument();
  }, [documentId]);

  return (
    <div className="min-h-screen bg-white dark:bg-zinc-900">
      <header className="bg-white shadow-sm dark:bg-zinc-800">
        <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <img src="/ks-logo-full-black.png" alt="KloudStax Logo" className="h-12 w-auto" />
            <img src="/google-cloud-logo.png" alt="Google Cloud Logo" className="h-12 w-auto" />
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <Heading>Document Preview</Heading>
          <button
            onClick={() => setIsEditing(!isEditing)}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            {isEditing ? 'Show Preview' : 'Edit Markdown'}
          </button>
        </div>
        
        <div className="mt-6">
          {isEditing ? (
            <textarea
              value={docMarkdown}
              onChange={(e) => setDocMarkdown(e.target.value)}
              className="w-full h-[500px] p-4 font-mono text-sm rounded-lg border border-zinc-200 dark:border-zinc-700 dark:bg-zinc-800 dark:text-white"
            />
          ) : (
            <div className="rounded-lg border border-zinc-200 bg-white p-6 prose prose-sm max-w-none dark:prose-invert dark:border-zinc-700 dark:bg-zinc-800">
              <ReactMarkdown className="[&>*:first-child]:mt-0"  remarkPlugins={[remarkGfm, remarkHeadingId]}>
                {docMarkdown}
              </ReactMarkdown>
            </div>
          )}
        </div>
      </main>

      <footer className="bg-white shadow-sm dark:bg-zinc-800 mt-auto">
        <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
          <p className="text-center text-sm text-zinc-500">
            © 2026 KloudStax. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default DocPreview; 